const WARRANTY_TYPES = [
  { valeu: "In-Warranty (OEM)", label: "In-Warranty (OEM)" },
  { valeu: "Out-of-Warranty", label: "Out-of-Warranty" },
];

export default WARRANTY_TYPES;
